(function() { module.exports = window["Next"]["Tab"]; }());